export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/info.8708d2a6.worker.js");
}
